import _extends from '@babel/runtime/helpers/esm/extends';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React from 'react';
import { useTheme } from '@paypalcorp/pp-react-theme';
import clsx from 'clsx';
import '../__generated__/styles/divider.css';

var styles = {"ppvx_divider":"ppvx_divider___3-6-9","ppvx_divider--inverse":"ppvx_divider--inverse___3-6-9","ppvx_divider--secondary":"ppvx_divider--secondary___3-6-9","ppvx--v2":"ppvx--v2___3-6-9","ppvx--v1":"ppvx--v1___3-6-9","pvx--v2":"pvx--v2___3-6-9"};

var _excluded = ["secondary", "inverse", "className", "theme"];

var Divider = function (_ref) {
  var _clsx;

  var secondary = _ref.secondary,
      inverse = _ref.inverse,
      className = _ref.className,
      theme = _ref.theme,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _theme = useTheme('Divider', theme);

  if (_theme !== 'v2') {
    console.warn('Divider 1.0 styles are deprecated. Use Divider 2.0 styles and refer to our Migration Guide on how to use 2.0 styles/components.');
  }

  var finalClasses = clsx(styles.ppvx_divider, (_clsx = {}, _defineProperty(_clsx, styles['ppvx_divider--inverse'], inverse), _defineProperty(_clsx, styles['ppvx_divider--secondary'], secondary), _defineProperty(_clsx, styles['ppvx--v2'], _theme && _theme === 'v2'), _clsx), className);
  return /*#__PURE__*/React.createElement("hr", _extends({
    className: finalClasses
  }, rest));
};

export { Divider };
